import React from "react";

import {s_char, s_char_mods} from "../_signals/s_char";
import {s_char_attr_step, s_char_attr_sum} from "../_signals/s_char_attr";

export function displayAttributeWithMod(attr) {
    const step = s_char_attr_step(attr).value;
    let value = 0;
    if (!s_char.value.nsc) {
        value = s_char_attr_sum(attr).value
    }
    const mod = s_char_mods.value.filter(m => m.what === attr).reduce((s, m) => s + m.mmod, 0);

    let valueDisp = <></>
    if (value!==0) {
        valueDisp = <>{' (' + value + ') '}</>
    }

    if (mod === 0) return <>{valueDisp}{step}</>;
    if (mod < 0) return <>{valueDisp}{step} {mod} <span> = {(step + mod)}</span></>;
    return <>{valueDisp}{step} +{mod} <> = {(step + mod)}</>
    </>;
}